import React, { useState } from 'react';

import './Alert.css';

export const Alert = props => {
    const [isHidden, setIsHidden] = useState(false);

    function handleCloseAlert() {
        setIsHidden(true);
        if (props.handleOnClose) {
            props.handleOnClose();
        }
    }
    return (
        <div role="alert" className={`alert alert-${props.type} ${isHidden ? 'hide-alert' : ''}`}>
            <div className="alert-content-wrapper">
                {props.children}
            </div>
            <button className="alert-close-button" onClick={handleCloseAlert} data-testid={`efup-alert-close-button-${props.dataTestId}`}>
                <i
                    className="cb-icon icon-close"
                />
            </button>
        </div>
    )
}